import darkTheme from 'shared/theme/dark.theme';
import defaultTheme from 'shared/theme/default.theme';
import doctorTheme from 'shared/theme/doctor.theme';
import { Theme } from 'types/CommonTypes';

const themeVariant = {
    [Theme.DOCTOR]: doctorTheme,
    [Theme.DEFAULT]: defaultTheme,
    [Theme.DARK]: darkTheme,
};

export default themeVariant;
